/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.querySelector('.signup-button').addEventListener('click', function () {
// // alert("hi")
//       document.getElementById('signupModal').style.display = 'block';
//     });

var newsletterBtn = document.querySelector('#newsletterForm button');
if (newsletterBtn) {
  newsletterBtn.addEventListener('click', function () {
    const toast = document.getElementById('toast');
    if (toast) {
      toast.style.display = 'block';
      setTimeout(() => {
        toast.style.display = 'none';
      }, 4000);
    }
  });
}
    // Close Modal
    function closeModal() {
      document.getElementById('signupModal').style.display = 'none';
      const emailInput = document.querySelector('#newsletterForm input[type="email"]');
      if (emailInput) emailInput.value = "";
    }

 const passwordPopup = document.getElementById('passwordPopup');
    const lockIcon = document.getElementById('lockIcon');

    // Open Password Popup
    if (lockIcon) {
      lockIcon.addEventListener('click', () => {
        passwordPopup.style.display = 'block';
      });
    }

    // Close Password Popup
    function closePasswordPopup() {
      passwordPopup.style.display = 'none';
    }

  
    window.addEventListener('click', function (e) {
      const modal = document.getElementById('signupModal');
      if (e.target === modal) {
        closeModal();
      }
    });




// Open cart drawer immediately on Add to Cart click — don't wait for the fetch to complete
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="add-to-cart"]');
    if (!btn) return;
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    // Open drawer right away so user sees it instantly
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }, true); // capture phase so it fires before theme.js preventDefault
})();

document.addEventListener('DOMContentLoaded', function() {
  const questions = document.querySelectorAll('.faq-question');
  
  questions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      question.classList.toggle('active');
      answer.classList.toggle('show');
      
      // Close other open answers in the same category
      const category = question.closest('.faq-category');
      category.querySelectorAll('.faq-question').forEach(q => {
        if (q !== question && q.classList.contains('active')) {
          q.classList.remove('active');
          q.nextElementSibling.classList.remove('show');
        }
      });
    });
  });
});